export default __webpack_public_path__ + "static/media/deviceManager.3210b0f4.jpg";